export default __webpack_public_path__ + "static/media/mobile-dev.7c4bfde0.png";